import useGetDateRangeSummary from './hooks/useGetDateRangeSummary';
import styled from 'styled-components';
import dayjs from 'dayjs';
import Text from 'components/Text';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import { useMemo } from 'react';
import appointmentSelectors from 'features/appointment/services/selectors';
import { first } from 'lodash';

const DateRangerSummary = () => {
  const [data] = useGetDateRangeSummary();
  const dispatch = useAppDispatch();
  const params = appointmentSelectors.paramsMasterData();
  const startDateParams = useMemo(() => dayjs(params?.date, 'MM-DD-YYYY').format('YYYY-MM-DD'), [params.date]);

  const handleChangeDate = (date: string) => {
    dispatch(appointmentActions.initData(dayjs(date, 'YYYY-MM-DD').format(DATE_FORMAT)));
  };

  const baseDateRanger = useMemo(() => {
    const startDate = dayjs();
    const endDate = dayjs().add(20, 'day');
    const dateRange = [];
    for (let i = startDate; i <= endDate; i = i.add(1, 'day')) {
      const item = {
        key: i.format('YYYY-MM-DD'),
        value: data?.find((item) => item.key === i.format('YYYY-MM-DD'))?.value || 0,
      };
      dateRange.push(item);
    }
    return dateRange;
  }, [data]);
  const firstItem = first(baseDateRanger);
  return (
    <Wrapper>
      <Item style={{ opacity: 0, pointerEvents: 'none' }}>
        <div className='date-label'>{dayjs(firstItem?.key, 'YYYY-MM-DD').format('ddd')}</div>
        <ItemKeyValue>
          <div className={'date-label'}>
            {dayjs(firstItem?.key, 'YYYY-MM-DD').format('DD')}
          </div>
          <div className='value'>{firstItem?.value}</div>
        </ItemKeyValue>
      </Item>
      <div className="scroll-container">
        <Container>
          {baseDateRanger?.map((item) => {
            const isActive = startDateParams === item.key;
            return (
              <Item key={item.key} onClick={() => handleChangeDate(item.key)}>
                <div className='date-label'>{dayjs(item.key, 'YYYY-MM-DD').format('ddd')}</div>
                <ItemKeyValue isActive={isActive}>
                  <div className={`date-label ${isActive ? 'active' : ''}`}>
                    {dayjs(item.key, 'YYYY-MM-DD').format('DD')}
                  </div>
                  <div className='value'>{item.value}</div>
                </ItemKeyValue>
              </Item>
            );
          })}
        </Container>
      </div>
    </Wrapper>
  );
};

export default DateRangerSummary;

const Wrapper = styled.div`
  flex: 1;
  align-self: stretch;
  position: relative;
  .scroll-container {
    position: absolute;
    inset: 0;
    overflow: auto;
    z-index: 2;
  }
`;

const Container = styled.div`
  display: flex;
  overflow-x: auto;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  padding-right: 16px;
  padding-bottom: 4px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`;

const Item = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .date-label {
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
  }
`;
const ItemKeyValue = styled.div<{ isActive?: boolean }>`
  width: 50px;
  height: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .label {
    text-align: center;
  }
  .date-label {
    color: #1d2129;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }
  .date-label.active {
    color: #fff;
  }
  .value {
    position: absolute;
    top: -18px;
    right: -20px;

    display: flex;
    width: 34px;
    height: 34px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
    border-radius: 100px;
    background: #0DA472;

    color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
  }
  ${({ isActive }) =>
    isActive &&
    `
    border-radius: 4px;
    background: #d2464f;
    color: #fff;
`}
`;
